import { FetchResult } from '@apollo/client'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'
import { GiftMessageSaveInput, MagentoGetCartGiftMessageOutput } from 'lib/types'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'

export interface VisitureAddGiftMessageMutationObject {
  mutation: {
    visitureAddGiftMessage: {
      __args: {
        input: {
          cart_id: string
          message: string
          sender: string
          recipient: string
          items: Array<{
            item_id: number
            message: string
            recipient: string
            sender: string
          }>
        }
      }
      message: boolean
      recipient: boolean
      sender: boolean
      items: {
        item_id: boolean
        message: boolean
        recipient: boolean
        sender: boolean
      }
    }
  }
}

export const visitureAddGiftMessageMutationObject: VisitureAddGiftMessageMutationObject = {
  mutation: {
    visitureAddGiftMessage: {
      __args: {
        input: {
          cart_id: '',
          message: '',
          sender: '',
          recipient: '',
          items: []
        }
      },
      message: true,
      recipient: true,
      sender: true,
      items: {
        item_id: true,
        message: true,
        recipient: true,
        sender: true
      }
    }
  }
}

export type VisitureAddGiftMessageMutation
  = (input: GiftMessageSaveInput)
  => Promise<FetchResult<{ visitureAddGiftMessage: MagentoGetCartGiftMessageOutput }>>

export const createVisitureAddGiftMessageMutation = (
  { getMutations }: ServiceDependencies
): VisitureAddGiftMessageMutation => async (input) => {
  const mutation = getMutations().visitureAddGiftMessageMutation

  mutation.mutation.visitureAddGiftMessage.__args.input = {
    cart_id: input.cartId,
    message: input.message,
    sender: input.sender,
    recipient: input.recipient,
    items: input.items.map(item => {
      return {
        item_id: item.cartItemId,
        message: item.message,
        recipient: item.recipient,
        sender: item.sender
      }
    })
  }

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
